module.exports = __webpack_public_path__ + "static/networks1-1d801dd5a6a5e44b7503e433b3a540b5.jpg";